import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import AssessmentCard from '../components/AssessmentCard';
import { assessments } from '../data/assessments';

export default function ComingSoonPage() {
  // Filter for upcoming assessments (all except PA, PIA, and DPIA)
  const upcomingAssessments = assessments.filter(
    assessment => !['pa', 'pia', 'dpia'].includes(assessment.id)
  );

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="bg-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto mb-12">
            <div className="inline-block">
              <h2 className="text-3xl font-bold mb-4 relative font-montserrat text-gray-700">
                Coming Soon
                <div className="absolute -bottom-2 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-brand-primary to-transparent opacity-75" />
              </h2>
            </div>
            <p className="text-lg text-gray-600 mt-6">
              Explore our upcoming privacy assessment offerings, designed to expand our comprehensive compliance solutions.
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {upcomingAssessments.map((assessment) => (
              <div key={assessment.id}>
                <AssessmentCard assessment={assessment} />
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}